'use strict';

const notImplementedError = Error('Not implemented');

export default class iHttpService {
  constructor(headers) {
    this.headers = headers || {};
  }
  get() {
    throw new notImplementedError;
  }
  post() {
    throw new notImplementedError;
  }
  patch() {
    throw new notImplementedError;
  }
}
